import AlertService from '@/shared/alert/alert.service';
import { Component, Inject, Vue } from 'vue-property-decorator';
import { SaciApi } from '@conacyt/saci-client';
import { CatalogoEntidades } from '@/shared/model/catalogoEntidades.model';
import { CatalogoMunicipios } from '@/shared/model/catalogoMunicipios.model';

@Component
export default class CatalogosAlumnoUtils extends Vue {
  @Inject('alertService') public alertService: () => AlertService;
  @Inject('saciApi') public saciApi: () => SaciApi;

  /**
   * Consulta catálogo completo de entidades
   *
   * @param pagina
   * @param catalogo en esquema {value: idEntidad, text: nombre}
   * @returns
   */
  public async getAllEntidades(pagina = 1, catalogo: CatalogoEntidades[] = []): Promise<Array<{ value: CatalogoEntidades; text: string }>> {
    let total = 0;

    try {
      const res = await this.saciApi().getAreaGeoestadisticaEstatal(pagina, 50);

      if (res?.headers?.['x-total-pages'] && total === 0) {
        total = Number(res.headers['x-total-pages']);
      }

      const entidades = Array.isArray(res.data) ? (res.data as CatalogoEntidades[]) : [];
      catalogo = catalogo.concat(entidades);

      if (pagina >= total) {
        return catalogo.map(item => ({
          value: item,
          text: item.nombre ?? '',
        }));
      }

      return this.getAllEntidades(pagina + 1, catalogo);
    } catch (err) {
      this.alertService().showError(this, err?.response?.data?.detail ?? this.$t('error.internalServerError').toString());
      return [];
    }
  }

  /**
   * Consulta catálogo completo de municipios de una entidad
   *
   * @param claveEntidad
   * @param pagina
   * @param catalogo en esquema {value: id, text: nombre}
   * @returns
   */
  public async getMunicipiosByEntidad(
    claveEntidad: string,
    pagina = 1,
    catalogo: CatalogoMunicipios[] = []
  ): Promise<Array<{ value: CatalogoMunicipios; text: string }>> {
    let total = 0;

    try {
      const res = await this.saciApi().getMunicipiosEstado(claveEntidad, pagina, 300);

      if (res?.headers?.['x-total-pages'] && total === 0) {
        total = Number(res.headers['x-total-pages']);
      }

      const municipios = Array.isArray(res.data) ? (res.data as CatalogoMunicipios[]) : [];
      catalogo = catalogo.concat(municipios);

      if (pagina >= total) {
        return this.itemsAsOptions(catalogo, item => item);
      }

      return this.getMunicipiosByEntidad(claveEntidad, pagina + 1, catalogo);
    } catch (err) {
      const detalle = err?.response?.data?.detail ?? this.$t('error.internalServerError').toString();
      this.alertService().showError(this, detalle);
      return [];
    }
  }

  /**
   * Convierte listado de opciones a un esquema {value,text} para utilizar en componentes de
   * selección.
   * El value puede ser determinado desde la llamada al método para poder asignar de forma dinámica
   * un objeto o atributo deseado
   *
   * @param items listado de opciones
   * @param determinaValue método que determina el valor a utilizar
   * @returns listo en esquema {value,text}
   */
  itemsAsOptions(items: any[], determinaValue: (item: any) => any): any[] {
    return items.map(item => ({
      value: determinaValue(item),
      text: item.nombre,
      disabled: false,
    }));
  }
}
